// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ctaContainer1 {
  position: absolute;
  background: rgb(195 197 248 / 20%);
  height: 230px;
  bottom: 0px;
  z-index: -1;
}
.ctaContainer {
  position: relative;
  margin: 50px 0px;
}
.cta {
  position: absolute;
  bottom: 0px;
}

.cta img {
  max-width: 90%;
}

.ctaBtnn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 20px;
}
.ctaBtnn img {
  width: auto;
  height: 100px;
}
.ctaContainer h2 {
  margin-top: 20px;
}
.ctaBtnn a {
  margin-top: 48px;
}
.ctaContainerTxt {
  padding-top: 50px;
}
.cta_certificates {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.cta_certificates img {
  width: auto;
  height: 50px;
  margin-right: 50px;
  margin-top: 20px;
}

@media (max-width: 576px) {
  .ctaContainerTxt {
    padding-top: 0px;
  }
  .ctaContainer img {
    width: 100%;
  }
  .ctaBtnn img {
    width: 45%;
    object-fit: contain;
  }
  .ctaContainer1 {
    height: 100%;
    top: 0px;
    left: 0px;
  }
  .cta_certificates {
    justify-content: center;
  }
  .cta_certificates img {
    width: auto !important;
  }
  .ctaBtnn {
    align-items: end;
    flex-direction: column;
  }
  .ctaContainerTxt {
    margin: 0px 20px;
  }
  .ctaBtnn {
    height: auto;
  }
  .cta_certificates img {
    margin: 20px 5px 0px 5px;
  }
}
@media only screen and (min-width: 576px) and (max-width: 992px) {
  .ctaContainer1 {
    height: 300px;
  }
  .cta img {
    height: 400px;
    object-fit: cover;
  }
  .ctaBtnn {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/component/home/Cta.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,aAAa;EACb,WAAW;EACX,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,QAAQ;IACR,SAAS;EACX;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;IACE,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,iBAAiB;EACnB;EACA;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".ctaContainer1 {\r\n  position: absolute;\r\n  background: rgb(195 197 248 / 20%);\r\n  height: 230px;\r\n  bottom: 0px;\r\n  z-index: -1;\r\n}\r\n.ctaContainer {\r\n  position: relative;\r\n  margin: 50px 0px;\r\n}\r\n.cta {\r\n  position: absolute;\r\n  bottom: 0px;\r\n}\r\n\r\n.cta img {\r\n  max-width: 90%;\r\n}\r\n\r\n.ctaBtnn {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding-bottom: 20px;\r\n}\r\n.ctaBtnn img {\r\n  width: auto;\r\n  height: 100px;\r\n}\r\n.ctaContainer h2 {\r\n  margin-top: 20px;\r\n}\r\n.ctaBtnn a {\r\n  margin-top: 48px;\r\n}\r\n.ctaContainerTxt {\r\n  padding-top: 50px;\r\n}\r\n.cta_certificates {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 100%;\r\n}\r\n.cta_certificates img {\r\n  width: auto;\r\n  height: 50px;\r\n  margin-right: 50px;\r\n  margin-top: 20px;\r\n}\r\n\r\n@media (max-width: 576px) {\r\n  .ctaContainerTxt {\r\n    padding-top: 0px;\r\n  }\r\n  .ctaContainer img {\r\n    width: 100%;\r\n  }\r\n  .ctaBtnn img {\r\n    width: 45%;\r\n    object-fit: contain;\r\n  }\r\n  .ctaContainer1 {\r\n    height: 100%;\r\n    top: 0px;\r\n    left: 0px;\r\n  }\r\n  .cta_certificates {\r\n    justify-content: center;\r\n  }\r\n  .cta_certificates img {\r\n    width: auto !important;\r\n  }\r\n  .ctaBtnn {\r\n    align-items: end;\r\n    flex-direction: column;\r\n  }\r\n  .ctaContainerTxt {\r\n    margin: 0px 20px;\r\n  }\r\n  .ctaBtnn {\r\n    height: auto;\r\n  }\r\n  .cta_certificates img {\r\n    margin: 20px 5px 0px 5px;\r\n  }\r\n}\r\n@media only screen and (min-width: 576px) and (max-width: 992px) {\r\n  .ctaContainer1 {\r\n    height: 300px;\r\n  }\r\n  .cta img {\r\n    height: 400px;\r\n    object-fit: cover;\r\n  }\r\n  .ctaBtnn {\r\n    flex-direction: column;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
